import { render, staticRenderFns } from "./discountPromotionDetails.vue?vue&type=template&id=1daece21&scoped=true"
import script from "./discountPromotionDetails.vue?vue&type=script&lang=js"
export * from "./discountPromotionDetails.vue?vue&type=script&lang=js"
import style0 from "./discountPromotionDetails.vue?vue&type=style&index=0&id=1daece21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daece21",
  null
  
)

export default component.exports